// extracted by mini-css-extract-plugin
export default {"wrap":"LockedScreen_wrap__VTTyh","icon":"LockedScreen_icon__Wk+80","text":"LockedScreen_text__gHVWx","btn":"LockedScreen_btn__0Y9B5"};